<template>
<div class="webinars">
    <router-view/>
</div>
</template>

<style lang="scss" src="@/styles/profile/webinars/groups.scss"></style>
